import React from 'react';
import { useTranslator } from 'tradera-lang/translate';

const OnDisplayBadge = ({ className }) => {
    const { t } = useTranslator();
    return (
        <span
            className={`badge badge-primary badge-inline text-nowrap ${className ||
                ''}`}>
            {t('itemCard_onDisplay')}
        </span>
    );
};

export default OnDisplayBadge;
